import { render } from "./MyAccountPacientsPage.vue?vue&type=template&id=d82b08fe&scoped=true"
import script from "./MyAccountPacientsPage.vue?vue&type=script&lang=js"
export * from "./MyAccountPacientsPage.vue?vue&type=script&lang=js"

import "./MyAccountPacientsPage.vue?vue&type=style&index=0&id=d82b08fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d82b08fe"]])

export default __exports__